import React, { useEffect, useState, createContext } from 'react';
import { useRouter } from 'next/router';
import { disableBodyScroll, enableBodyScroll } from './RemoveScroll.utils';
import { isBrowser } from '../../util/ssr';
if (isBrowser())
    window.__BOM_modalCount = 0;
export var RemoveScrollContext = createContext({
    toggleScrollLock: function () { },
    onAfterScrollEnable: function () { }
});
var RemoveScrollProvider = function (_a) {
    var children = _a.children;
    var _b = useState(undefined), isLocked = _b[0], setIsLocked = _b[1];
    var _c = useState(undefined), afterEnableFunc = _c[0], setAfterEnableFunc = _c[1];
    var router = useRouter();
    // Reset scroll lock on route changes for client-side routing
    useEffect(function () {
        var handleRouteChange = function () {
            if (window.__BOM_modalCount > 0) {
                // Reset modal count and enable scroll when navigating away
                window.__BOM_modalCount = 0;
                setIsLocked(false);
            }
        };
        router.events.on('routeChangeStart', handleRouteChange);
        router.events.on('routeChangeComplete', handleRouteChange);
        return function () {
            router.events.off('routeChangeComplete', handleRouteChange);
            router.events.off('routeChangeStart', handleRouteChange);
        };
    }, [router]);
    useEffect(function () {
        if (isLocked === true) {
            disableBodyScroll();
        }
        else if (isLocked === false && window.__BOM_modalCount > 0) {
            setIsLocked(true);
        }
        else if (isLocked === false && window.__BOM_modalCount === 0) {
            enableBodyScroll();
            if (afterEnableFunc && typeof afterEnableFunc === 'function') {
                afterEnableFunc();
                setAfterEnableFunc(undefined);
            }
        }
    }, [isLocked, afterEnableFunc]);
    var requestDisableScroll = function () { return setIsLocked(true); };
    var requestEnableScroll = function () { return setIsLocked(false); };
    var onAfterScrollEnable = function (cb) { return setAfterEnableFunc(function () { return cb; }); };
    var toggleScrollLock = function (shouldLock) {
        if (shouldLock) {
            window.__BOM_modalCount += 1;
            requestDisableScroll();
        }
        else {
            window.__BOM_modalCount -= 1;
            requestEnableScroll();
        }
    };
    return (React.createElement(RemoveScrollContext.Provider, { value: { toggleScrollLock: toggleScrollLock, onAfterScrollEnable: onAfterScrollEnable } }, children));
};
export default RemoveScrollProvider;
